import { Button, Card, DatePicker, message, notification, Select, Upload } from "antd"
import Form from "antd/es/form/Form"
import Input from "antd/es/input/Input"
import Title from "antd/es/typography/Title"
import { CreateAccount, GetAllRoles } from "../../../api/AdminService"
import { useNavigate } from "react-router-dom"
import dayjs from "dayjs"
import { useEffect, useState } from "react"
import { EyeInvisibleOutlined, EyeTwoTone, ArrowLeftOutlined } from '@ant-design/icons';
import { Option } from "antd/es/mentions"
const AdminAddAccount = () => {
    const [roles, setRoles] = useState([]);
    const [Loading, setLoading] = useState(false);
    const navigate = useNavigate()
    const GetAllRole = () => {
        GetAllRoles().then(res => {
            if (res.status === 200) {
                console.log(res.data)
                setRoles(res.data)
            }
        })
    }

    useEffect(() => {
        GetAllRole();
    }, [])

    const onFinish = (values) => {
        setLoading(true);
        CreateAccount(
            values.roleId,
            values.email,
            values.password,
            values.phoneNumber,
            values.firstName,
            values.lastName,
            dayjs(values.dateOfBirth).format('YYYY-MM-DD'),
            values.gender
        ).then(res => {
            if (res.status === 201) {
                console.log(res)
                notification.success({
                    message: "Created Retreat Successfully"
                })
                setTimeout(navigate("/Admin/Account"), 2000);
                setLoading(false);
            }
        }).catch(err => {
            console.log(err.response)
            notification.error({
                message: `${err.response.data.message}`
            })
            setLoading(false);
        })
    }


    return (
        // <div>AdminAddAccount</div>
        <div style={{ minHeight: '96.5vh', Width: '100%' }}>
            <Button
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate(-1)}
                style={{ marginBottom: 16 }}
            >
                Go Back
            </Button>
            <div style={{ maxWidth: 600, margin: 'auto', padding: '24' }}>
                <Title level={2} style={{ textAlign: 'center', marginBottom: '24' }}>
                    Create Account
                </Title>
                <Form
                    onFinish={onFinish}
                    name="wrap"
                    labelAlign="left"
                    labelWrap
                    labelCol={{ flex: '150px' }}
                >
                    <Card title="Requirement Information" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: 20 }}>
                        <Form.Item name={"email"} label="Email" 
                        rules={[
                            { required: true, message: 'Requiring email' },
                            { type: 'email', message: 'The input is not valid E-mail!' }
                        ]}>
                            <Input
                                placeholder="Input Email"
                            />
                        </Form.Item>
                        <Form.Item name={"password"} label="Password" 
                        rules={[
                            { required: true, message: 'Requiring password' },
                            { 
                                validator: (_, value) => {
                                    if (!value || (value.length >= 8 && /[A-Z]/.test(value) && /[!@#$%^&*]/.test(value))) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('Password must be at least 8 characters long, contain at least one uppercase letter and one special character'));
                                }
                            }
                        
                        ]}>
                            <Input.Password
                                placeholder="Input Password"
                                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                            />
                        </Form.Item>
                        <Form.Item name={"phoneNumber"} label="Phone Number" 
                        rules={[
                            { required: true, message: 'Requiring phone number' },
                            {
                                pattern: /^[0-9]{10}$/, 
                                message: 'Phone number format is not correct'
                            }
                            
                        ]}>
                            <Input
                                placeholder="Input Phone Number"
                            />
                        </Form.Item>
                        <Form.Item name={"roleId"} label="Choose role"
                            rules={[
                                {
                                    required: true,
                                    message: 'Requiring Role',
                                },
                            ]}
                        >
                            <Select
                                placeholder="Choose role"
                            >
                                {roles.map((item) => (
                                    <Option key={item.id} value={item.id}>
                                        {item.name}
                                    </Option>
                                ))}

                            </Select>
                        </Form.Item>
                    </Card>
                    <Card title="Basic Information" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: 20 }}>
                        <Form.Item name={"firstName"} label="First Name" rules={[{ required: true, message: 'Requiring First Name'  }]}>
                            <Input
                                placeholder="Input First Name"
                            />
                        </Form.Item>
                        <Form.Item name={"lastName"} label="Last Name" rules={[{ required: true, message: 'Requiring Last Name' }]}>
                            <Input
                                placeholder="Input Last Name"
                            />
                        </Form.Item>
                        <Form.Item name={"dateOfBirth"} label="Date of Birth" rules={[{ required: true, message: 'Requiring Date of birth' }]}>
                            <DatePicker />
                        </Form.Item>
                        <Form.Item name={"gender"} label="Gender" rules={[{ required: true, message: 'Requiring Gender' }]}>
                            <Select
                                placeholder='Choose Gender'
                            >
                                <Option key={1} value="Male">Male</Option>
                                <Option key={2} value="FeMale">FeMale</Option>
                            </Select>
                        </Form.Item>
                    </Card>
                    <Form.Item >
                        <Button block type="primary" htmlType="submit" loading={Loading}>
                            {Loading ? "Processing..." : "Create Account"}
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    )

}
export default AdminAddAccount
